<template>
    <div class="projects-container">
        <div class="project-cards-wrapper">
            <div v-for="(project, i) in filteredProjects" :key="i" class="project-card">
                <div class="card-container">
                    <div class="project-info">
                        <div class="project-name">{{ project.gameName }}</div>
                        <div class="project-company">
                            Due: {{ formatEndTime(project.endTime) }}
                        </div>
                    </div>

                    <img v-if="project.img" class="project-img" :src="project.img" />
                    <div v-else class="project-img-placeholder"></div>

                    <div class="project-buttons">
                        <b-button 
                            class="project-button-details" 
                            @click="handleJoin(project.gameId)">
                            Join
                        </b-button>
                        
                        <b-button 
                            class="project-button-survey" 
                            @click="showDetailsPopup(project.gameName, project.gameDescription, project.img)">
                            Details
                        </b-button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="detailsPopupVisible" class="popup-overlay" @click="closeDetailsPopup">
            <div class="popup-content" @click.stop>
                <button class="btn-close-circle--dark" @click="closeDetailsPopup">×</button>
                <div class="popup-body">
                    <img v-if="selectedProject.img && selectedProject.img !== ''" 
                        class="popup-img" 
                        :src="selectedProject.img" 
                        alt="Project Image" />
                    <div class="popup-text">
                        <h3 class="popup-title">{{ selectedProject.name }}</h3>
                        <p class="popup-description">{{ selectedProject.description }}</p>
                    <div class="popup-meta">
                     <div class="popup-tags">
                        <span class="popup-tag" v-for="tag in selectedProject.tags" :key="tag">{{ tag }}</span>
                    </div>
                    <div class="popup-meta-col">
                        <span class="popup-meta-item">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                    {{ selectedProject.playtestTime }}
                        </span>
                <span class="popup-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
                {{ selectedProject.platform }}
                </span>
                         </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { joinProject } from '../../Firestore/GamesObject.js'

export default {
    name: "ProjectCardTesterDiscover",
    props: {
        projects: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,
            userID: window.localStorage.getItem("userId"),
            detailsPopupVisible: false,
            selectedProject: {
                name: '',
                description: '',
                img: '',
                tags: ['Tag 1', 'Tag 2', 'Tag 3' ],
                playtestTime: '10-15 min',
                platform: 'Web build'
            }
        }
    },
    computed: {
        filteredProjects() {
            if (!this.projects) return [];
            return this.projects.filter(project => {
                return !project.testerIDs || !project.testerIDs.includes(this.userID);
            });
        }
    },
    methods: {
        formatEndTime(endTime) {
            if (!endTime) return '--';
            const date = new Date(endTime);
            return date.toLocaleString('en-US', {
                year: '2-digit', month: '2-digit', day: '2-digit',
                hour: 'numeric', minute: 'numeric', hour12: true
            });
        },
        async handleJoin(gameId) {
            const userId = this.userID;
            const result = await joinProject(gameId, userId);
            if (result.success) {
                alert("Successfully joined the project!");
                window.location.reload();
            } else {
                alert("Failed to join the project: " + result.error);
            }
        },
        showDetailsPopup(gameName, gameDescription, gameImg) {
            this.selectedProject.name = gameName;
            this.selectedProject.description = gameDescription || 'No description Available.';
            this.selectedProject.img = gameImg;
            this.detailsPopupVisible = true;
        },
        closeDetailsPopup() {
            this.detailsPopupVisible = false;
        }
    }
}
</script>

<style scoped>
/* Container & Wrapper */
.projects-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
}

.project-cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
}

/* Card Styling */
.project-card {
    background-color: white;
    border-radius: 12px;
    margin: 1rem;
    border: 1px solid #eaeaea;
    transition: box-shadow 0.2s;
    width: 250px;
    min-height: 370px; /* Adjust this value to change card height */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 2px 20px 30px 20px; 
    position: relative;
    display: flex;
    flex-direction: column;
}

.project-card:hover {
    box-shadow: 0 4px 8px rgba(255, 142, 77, 0.612);
}


.card-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start; 
    text-align: left;
    height: 100%; 
    justify-content: space-between;
}

.project-info {
    width: 100%; 
}

.project-name {
    color: #333;
    font-weight: bold;
    font-size: 1.2rem;
    margin-top: 10px;
}

.project-company {
    color: #888;
    font-style: italic;
    font-size: 0.9rem;
}

.project-img, .project-img-placeholder {
    width: 100%;
    height: 180px; /* Consistent big picture */
    object-fit: cover;
    border-radius: 8px;
    margin-top: 2px;
}

.project-img-placeholder {
    background-color: #f0f0f0;
}

/* Button Styling */
.project-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    width: 100%;
    gap: 15px;
}

.project-button-details, .project-button-survey {
    background: #FF7222;
    border: 0;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    flex: 1;
    cursor: pointer;
    transition: background 0.2s;
}

.project-button-details:hover, .project-button-survey:hover {
    background: #ff8e4d;
}

/* Popup Styles - MATCHES SCRIPT 2 */
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.popup-content {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    max-width: 500px;
    width: 90%;
    height: 300px;
    max-height: 80vh;
    overflow-y: auto;
    position: relative;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    display:flex;
    flex-direction: column;
}

.popup-body {
    display: flex;
    gap: 1rem;
    align-items: stretch;
    flex: 1;
    min-height: 0;
}

.popup-img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    flex-shrink: 0;
    align-self: center;
}

.popup-text {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.popup-tags { 
    display: flex; 
    flex-wrap: wrap; 
    gap: 6px; 
}

.popup-tag { 
    background: #eef2ff; color: #3730a3; 
    font-size: 12px; 
    padding: 4px 10px; 
    border-radius: 6px; 
}
.popup-meta {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
    font-size: 13px;
    color: #6b7280;
}

.popup-meta-col {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.popup-meta-item { 
    display: flex; 
    align-items: center; 
    gap: 4px; 
}



.popup-title {
    color: #333;
    font-weight: bold;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    margin-top: 0;
}

.popup-description {
    .popup-description {
    color: #666;
    line-height: 1.6;
    margin: 0;
    height: 120px;
    overflow-y: auto;
}
}

/* Responsive Adjustments */
@media only screen and (max-width: 700px) {
    .popup-body {
        flex-direction: column;
        text-align: center;
    }
    .popup-img {
        align-self: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/game-dashboard/ProjectCardTesterDiscover.vue